//------------------------------------------------------------------------------
// BFA10109G 共架申込 内容確認
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {
  PositiveButton,
  StandardButton,
} from '@/components/atoms/Buttons/PositiveButton';

/**
 * 操作パネル
 */
function ConfirmPanel({
  orderNo,
  navigate,
}) {

  // 申込基本情報ボタン
  const handleBack = () => {
    console.info(`基本情報 order=${orderNo}`);
    if (orderNo.valid()) {
      navigate('/bfa10102g/' + orderNo.path());
    }
  }

  // 機器設備ボタン
  const handleSetubi = () => {
    console.info(`機器設備 order=${orderNo}`);
    if (orderNo.valid()) {
      navigate('/bfa10103g/' + orderNo.path());
    }
  }

  // 通信設備ボタン
  const handleTusin = () => {
    console.info(`通信設備 order=${orderNo}`);
    if (orderNo.valid()) {
      navigate('/bfa10104g/' + orderNo.path());
    }
  }

  //----------------------------------------------------------------------------
  // 描画
  //----------------------------------------------------------------------------
  // 画面遷移可否
  const navigatable = orderNo?.valid();

  // 操作パネル描画
  return (
    <Grid container spacing={1}
      sx={{
        mt: 2,
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      {/* 承認申請 */}
      <Grid item>
        <PositiveButton
          variant="contained"
          size="large"
          disabled={!navigatable}
        >
          <span>承認申請</span>
        </PositiveButton>
      </Grid>

      {/* 通信設備 */}
      <Grid item>
        <StandardButton
          variant="contained"
          size="large"
          disabled={!navigatable}
          startIcon={<KeyboardReturnIcon />}
          onClick={handleTusin}
        >
          <span>通信設備に戻る</span>
        </StandardButton>
      </Grid>

      {/* 機器設備 */}
      <Grid item>
        <StandardButton
          variant="contained"
          size="large"
          disabled={!navigatable}
          startIcon={<KeyboardReturnIcon />}
          onClick={handleSetubi}
        >
          <span>機器設備に戻る</span>
        </StandardButton>
      </Grid>

      {/* 申込基本情報 */}
      <Grid item>
        <StandardButton
          variant="contained"
          size="large"
          startIcon={<KeyboardReturnIcon />}
          onClick={handleBack}
        >
          <span>基本情報に戻る</span>
        </StandardButton>
      </Grid>
    </Grid>
  );
}

// プロパティ
ConfirmPanel.propTypes = {
  orderNo: PropTypes.object,  // 申込番号

  // ルーティング
  navigate: PropTypes.func,
};

// エクスポート
export default ConfirmPanel;
